"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LevelPriority = exports.Level = void 0;
var Level;
/**
 * Log level priority. A lower number means lower priority.
 * This is used in the followeding fashion. If the global or local priority is set at X, then only
 * messages with a priority greater than or equal to X are output. Others are ignored.
 *
 * So, when the global priority is set at error (default for production env), only error messages
 * are emitted and everything else is ignored.
 *
 * Locally, the global priority is set at debug. Therefore, debug, log, info, warn, and error
 * messages are all emitted.
 *
 * You can change the global priority (or local priority of individual logger instances) to any
 * level to suit your particular use case by invoking `setLoggingLevel()`.
 */

exports.Level = Level;

(function (Level) {
  Level["none"] = "none";
  Level["error"] = "error";
  Level["warn"] = "warn";
  Level["info"] = "info";
  Level["log"] = "log";
  Level["debug"] = "debug";
})(Level || (exports.Level = Level = {}));

var LevelPriority;
exports.LevelPriority = LevelPriority;

(function (LevelPriority) {
  LevelPriority[LevelPriority["none"] = 10] = "none";
  LevelPriority[LevelPriority["error"] = 4] = "error";
  LevelPriority[LevelPriority["warn"] = 3] = "warn";
  LevelPriority[LevelPriority["info"] = 2] = "info";
  LevelPriority[LevelPriority["log"] = 2] = "log";
  LevelPriority[LevelPriority["debug"] = 1] = "debug";
})(LevelPriority || (exports.LevelPriority = LevelPriority = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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